import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ColDef, GridApi, GridReadyEvent, SelectionChangedEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AgGridActionbutton } from 'src/app/shared/common/AgGridActionbutton';
import { AsignUserRoleService } from 'src/app/shared/services/asign-user-role.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ProductsAssignedToRolesService } from 'src/app/shared/services/products-assigned-to-roles.service';
import { ProductGroupPopupComponent } from '../product-group-product-mapping/product-group-popup/product-group-popup.component';
import { MatDialog } from '@angular/material/dialog';

interface UserRoles {
  rolename?: string;  
  userrolesmstrid?:any;
}

@Component({
    selector: 'app-role-product-group-mapping',
    templateUrl: './role-product-group-mapping.component.html',
    styleUrls: ['./role-product-group-mapping.component.scss'],
    standalone: false
})
export class RoleProductGroupMappingComponent implements OnInit {

   gridApi!: GridApi;
   isGridLoading = true;
   userRoleOptions:UserRoles[]=[]
  userRoleNameData:any;
  selectedUserRole:any;
  selectedDnsName:any;

  roles: any[] = [];
  filteredRoles: any[] = [];
  selectedRole: any = null;

  rowData: any[] = [];
  filteredRowData: any[] = [];

  roleSearchText = '';
  productGroupSearchText = '';
  mappingFilter = 'ALL';

  columnDefs: ColDef[] = [];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      }
  };

  pageSize = 50;
  currentPage:any = 1;
  totalPages = 1;
  totalRows = 0;
  startRow = 1;
  endRow = 50;
  selectedProductGroup:any=[];
  components: any={
    buttonRenderer: AgGridActionbutton
  }

   constructor( private asignUserRoleService: AsignUserRoleService,
      private spinner: NgxUiLoaderService,
      private snackBar: MatSnackBar,
      private localStorageSettings: LocalStorageSettingsService,
      private services:ProductsAssignedToRolesService,
      private dialog: MatDialog
    ) { }

 ngOnInit(): void {
    this.selectedDnsName=this.localStorageSettings.getSettings("SelectedDnsName");
    this.getUserRoles()
    this.columnDefs=[
       {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 80,
      pinned: 'left',
      lockPosition: true
    },
     { 
      headerName: 'Product Group Name', 
      field: 'product_group_name',
      headerTooltip:'Product Group Name', 
      sortable: true,
      tooltipValueGetter: (params) => 'Product Group Name : ' + params.value,
      filter: 'agTextColumnFilter',
      width: 250,
    },
     { 
      headerName: 'Created By', 
      headerTooltip:'Created By', 
      field: 'createdBy',
      sortable: true,
      tooltipValueGetter: (params) => 'Created By : ' + params.value,
      filter: 'agTextColumnFilter',
       width: 250,
    },
     { 
      headerName: 'Created Date', 
      headerTooltip:'Created Date',
      field: 'createdDate',
      sortable: true,
      tooltipValueGetter: (params) => 'Created Date : ' + params.value,
      filter: 'agTextColumnFilter',
      width: 250,
    },
    { 
      headerName: 'Last Modified By', 
      headerTooltip:'Last Modified By',
      field: 'lastmodifiedBy',
      sortable: true,
      tooltipValueGetter: (params) => 'Last Modified By : ' + params.value,
      filter: 'agTextColumnFilter',
      width: 250
    },
     { 
      headerName: 'Last Modified Date', 
      headerTooltip:'Last Modified Date',
      field: 'lastModifiedDate',
      sortable: true,
      tooltipValueGetter: (params) => 'Last Modified Date : ' + params.value,
      filter: 'agTextColumnFilter',
      width: 250,
    },
    
    { 
      headerName: 'Status', 
      headerTooltip:'Status',
      field: 'status',
      sortable: true,
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      filter: 'agTextColumnFilter',
      width: 150,
    },
    {
          headerName: '', 
          filter: false, 
          width:180,
          cellRenderer: 'buttonRenderer',
          pinned:'right',
          lockPinned:true,
          cellRendererParams: {
            edit: this.EditIcon.bind(this),
            delete: this.deleteIcon.bind(this),
          }, 
        }
    ]
  }
  EditIcon(event){
     let dialogRef = this.dialog.open(ProductGroupPopupComponent, {
            width: "35%",
            autoFocus: false,
            height: "35%",
            disableClose: true,
            data: {editData: event.rowData},
          });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if(result == 1){
           this.loadProductGroupsByRole(this.selectedRole.userrolesmstrid);
        }
      });
  }
  deleteIcon(event){
    
    if(confirm("Are you sure you want to delete this Product Group?")){
       this.services.deleteProductGroup(event.rowData.product_group_id).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });


      } else {
        console.log(response);
        
         this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
         this.loadProductGroupsByRole(this.selectedRole.userrolesmstrid);
        // this.spinner.stop();

      }
    });
    }
    
  }
  getUserRoles(){
    this.spinner.start();
    let workspaceId=this.localStorageSettings.getSettings("WorkspaceId");
    this.asignUserRoleService.reteriveUserRoleMstrByDnsId(workspaceId).subscribe(response => {

      console.log(response)

      if (response.error == true) {

        this.spinner.stop();
        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
        return null;
      }
      else {
        

        this.userRoleNameData = response;
        console.log(this.userRoleNameData);
        this.userRoleOptions=this.userRoleNameData
        this.filteredRoles = [...this.userRoleOptions];

        if (this.filteredRoles.length > 0) {
          this.onRoleSelect(this.filteredRoles[0]);
        }
        this.spinner.stop();
      }

    });
  }

  onGridReady(params: GridReadyEvent): void {
      this.gridApi = params.api;
      this.isGridLoading = false;
      
      // Auto-size columns on load
      setTimeout(() => {
        if (this.gridApi) {
          this.gridApi.sizeColumnsToFit();
        }
      }, 100);
  
      // Add click event listener for action buttons
      params.api.addEventListener('cellClicked', (event: any) => {
        if (event.column.colId === 'actions') {
          // this.onCellClicked(event);
        }
      });
    }

  

  filterRoles(): void {
    const search = this.roleSearchText?.toLowerCase()?.trim();
console.log(search);

    if (!search) {
      this.filteredRoles = [...this.userRoleOptions];
      return;
    }
console.log(this.roles);

    this.filteredRoles = this.userRoleOptions.filter(role =>
      role.rolename?.toLowerCase().includes(search)
    );
  }

  onRoleSelect(role: any): void {
    this.selectedRole = role;
    this.productGroupSearchText = '';
    this.mappingFilter = 'ALL';
    this.loadProductGroupsByRole(role.userrolesmstrid);
  }

  loadProductGroupsByRole(roleId: number): void {
    this.spinner.start();
    // replace with actual API
    // this.service.getProductGroupsByRole(roleId).subscribe(res => { ... });
this.services.retrieveProductGroupToRoles(roleId).subscribe(response=>{
if (response.error == true) {

        this.spinner.stop();
        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
        return null;
      }
      else {
        console.log(response);
        let data:any=response
         this.rowData =data;
         this.totalRows = this.rowData.length;

          this.totalPages = Math.ceil(this.totalRows / this.pageSize);

           // Update display values
        this.startRow = ((this.currentPage - 1) * this.pageSize) + 1;
        this.endRow = Math.min(this.currentPage * this.pageSize, this.totalRows);
        this.applyProductGroupFilter();

    setTimeout(() => {
      if (!this.gridApi) return;

      this.gridApi.deselectAll();
      this.gridApi.forEachNode(node => {
        if (node.data?.mapped === true) {
          node.setSelected(true);
        }
      });
    }, 100);
         this.spinner.stop();
      }
})
    // this.rowData = [];

    
  }

  applyProductGroupFilter(): void {
    const search = this.productGroupSearchText?.toLowerCase()?.trim();

    this.filteredRowData = this.rowData.filter(row => {
      const matchesSearch =
        !search || row.product_group_name?.toLowerCase().includes(search);

      const matchesMapping =
        this.mappingFilter === 'ALL' ||
        (this.mappingFilter === 'MAPPED' && row.mapped) ||
        (this.mappingFilter === 'UNMAPPED' && !row.mapped);

      return matchesSearch && matchesMapping;
    });

    setTimeout(() => {
      if (!this.gridApi) return;

      this.gridApi.deselectAll();
      this.gridApi.forEachNode(node => {
        if (node.data?.mapped === true) {
          node.setSelected(true);
        }
      });
    }, 100);
  }

    goToFirst() {
    this.gridApi?.paginationGoToFirstPage();
    this.onPageChange();
  }

  goToPrevious() {
    this.gridApi?.paginationGoToPreviousPage();
    this.onPageChange();
  }

  goToNext() {
    this.gridApi?.paginationGoToNextPage();
    this.onPageChange();
  }

  goToLast() {
    this.gridApi?.paginationGoToLastPage();
    this.onPageChange();
  }

  onPageChange() {
    let currentpage:any = this.gridApi?.paginationGetCurrentPage();
    this.currentPage=currentpage+1
    if(this.currentPage != this.gridApi?.paginationGetTotalPages()){
      this.startRow = currentpage * this.pageSize +1;
      this.endRow = this.startRow + this.pageSize - 1;
    }else{
        this.startRow = currentpage * this.pageSize +1;
        this.endRow = this.totalRows;
    }
  }

  onSelectionChanged(event: SelectionChangedEvent): void {
          this.selectedProductGroup = event.api.getSelectedRows();
          console.log(this.selectedProductGroup);
          
  }

  resetSelection(): void {
    if (!this.selectedRole) return;
    this.loadProductGroupsByRole(this.selectedRole.roleid);
  }

  saveRoleProductGroupMapping(): void {
    if (!this.selectedRole || !this.gridApi) return;

    const selectedProductGroupIds: number[] = [];

    this.gridApi.getSelectedNodes().forEach(node => {
      if (node.data?.product_group_id) {
        selectedProductGroupIds.push(node.data.product_group_id);
      }
    });

    const payload = {
      roleId: this.selectedRole.roleid,
      productGroupIds: selectedProductGroupIds,
      updatedBy: 'currentUser'
    };

    console.log('Save payload:', payload);

    // this.service.saveRoleProductGroups(payload).subscribe(res => { ... });
  }

  onRefresh(){

  }

  onMapProductGroupClick(){
     const selectedProductGroupIds = this.selectedProductGroup.map(item => item.product_group_id);
        let insertProductsObject={
          role_id:this.selectedRole.userrolesmstrid,
          product_group_id:selectedProductGroupIds
        }
        this.spinner.start();
       this.services.insertProductGroupByRole(insertProductsObject).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });


      } else {
        console.log(response);
        
         this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
        this.spinner.stop();

      }
    });

  }
 onCreateProductGroup(){
     let dialogRef = this.dialog.open(ProductGroupPopupComponent, {
            width: "35%",
            autoFocus: false,
            height: "35%",
            disableClose: true,
            data: {},
          });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if(result == 1){
           this.loadProductGroupsByRole(this.selectedRole.userrolesmstrid);
        }
      });
  }
}
